import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { MarqueeBar } from "@/components/MarqueeBar";
import { Portfolio } from "@/components/Portfolio";
import { ServicesContact } from "@/components/ServicesContact";
import { Footer } from "@/components/Footer";

function App() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <div className="noise-overlay" />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0c0c0c",
            border: "1px solid rgba(92,198,255,0.3)",
            color: "#f5f5f5",
            borderRadius: 0,
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
      <Navbar />
      <main>
        <Hero />
        <About />
        <MarqueeBar items={["Raw Action", "TMB Fotografia", "Untamed Kinetics", "Matchday"]} />
        <Portfolio />
        <ServicesContact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
